<template>
  <div class="pie-chart">
    <canvas :id="chartId" width="80" height="80"></canvas>
  </div>
</template>

<script>
export default {
  name: "M.PieChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    chartId: {
      type: String,
      required: true,
    },
  },
  watch: {
    chartData() {
      this.drawPieChart();
    },
  },
  computed: {
    total() {
      if (!this.chartData) return 0;
      return this.chartData
        .map(item => item.value)
        .reduce((item, sum) => {
          return item + sum;
        }, 0);
    },
    data() {
      return this.chartData.map(item => {
        const percent = item.value / this.total;
        return {
          value: percent,
          color: item.color,
        };
      });
    },
  },
  methods: {
    // 円グラフを描画する関数
    drawPieChart() {
      const canvas = document.getElementById(this.chartId);
      const context = canvas.getContext("2d");
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = Math.min(centerX, centerY);

      let startAngle = -0.5 * Math.PI;

      // 各項目ごとに扇形を描画
      this.data.forEach(item => {
        const endAngle = startAngle + item.value * Math.PI * 2;

        // 扇形を描画
        context.beginPath();
        context.moveTo(centerX, centerY);
        context.arc(centerX, centerY, radius, startAngle, endAngle, false);
        context.closePath();
        context.fillStyle = item.color;
        context.fill();

        startAngle = endAngle;
      });
    },
  },
  mounted() {
    // 円グラフを描画
    this.drawPieChart();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

.pie-chart {
  width: 80px;
  height: 80px;
}
</style>
